// Dev-only console helpers. Stripped from production builds so end users
// never see noisy diagnostics, while engineers retain rich logs in dev.
// Use these instead of bare `console.warn` / `console.error`.
const isDev = process.env.NODE_ENV !== "production";

export const devWarn = (...args) => {
  if (isDev) console.warn(...args);
};

export const devError = (...args) => {
  if (isDev) console.error(...args);
};

export const devLog = (...args) => {
  if (isDev) console.log(...args);
};
